import React, { useEffect, useState } from 'react';
import { X, CheckCircle } from 'lucide-react';
const cities = ['Bogotá', 'Medellín', 'Cali', 'Barranquilla', 'Bucaramanga', 'Pereira'];
const namesF = ['María', 'Valentina', 'Camila', 'Laura', 'Daniela', 'Carolina', 'Andrea', 'Natalia'];
const namesM = ['Andrés', 'Juan', 'Camilo', 'Santiago', 'Felipe', 'David', 'Alejandro', 'Daniel'];
const lastNames = ['G.', 'M.', 'R.', 'P.', 'S.', 'T.', 'C.', 'L.'];
const positions = ['bottom-4 right-4', 'bottom-4 left-4', 'top-20 right-4'];
export function PurchaseNotification() {
  const [isVisible, setIsVisible] = useState(false);
  const [notification, setNotification] = useState({
    name: '',
    city: '',
    position: positions[0]
  });
  const [isEnabled, setIsEnabled] = useState(true);
  useEffect(() => {
    if (!isEnabled) return;
    const showNotification = () => {
      const isFemale = Math.random() > 0.4;
      const firstNames = isFemale ? namesF : namesM;
      const name = `${firstNames[Math.floor(Math.random() * firstNames.length)]} ${lastNames[Math.floor(Math.random() * lastNames.length)]}`;
      const city = cities[Math.floor(Math.random() * cities.length)];
      const position = positions[Math.floor(Math.random() * positions.length)];
      setNotification({
        name,
        city,
        position
      });
      setIsVisible(true);
      setTimeout(() => setIsVisible(false), 5000);
    };
    const initialTimer = setTimeout(showNotification, 15000);
    const loop = () => {
      const nextInterval = Math.floor(Math.random() * (45000 - 25000 + 1) + 25000);
      setTimeout(() => {
        if (isEnabled) {
          showNotification();
          loop();
        }
      }, nextInterval);
    };
    const loopTimer = setTimeout(loop, 15000);
    return () => {
      clearTimeout(initialTimer);
      clearTimeout(loopTimer);
    };
  }, [isEnabled]);
  if (!isEnabled) return null;
  return <div className={`fixed z-50 transition-all duration-500 ease-in-out ${notification.position} ${isVisible ? 'opacity-100 translate-y-0 scale-100' : 'opacity-0 translate-y-4 scale-95 pointer-events-none'}`} data-id="element-229">
      <div className="bg-white shadow-xl rounded-xl p-4 pr-10 flex items-center gap-3 max-w-sm border border-warm-200" data-id="element-230">
        <button onClick={() => setIsVisible(false)} className="absolute top-2 right-2 text-text-muted hover:text-text-dark transition-colors" data-id="element-231">
          <X className="w-4 h-4" data-id="element-232" />
        </button>

        <div className="bg-green-100 p-2 rounded-full shrink-0" data-id="element-233">
          <CheckCircle className="w-5 h-5 text-green-600" data-id="element-234" />
        </div>

        <div data-id="element-235">
          <p className="text-sm text-text-body" data-id="element-236">
            <span className="font-semibold text-text-dark" data-id="element-237">
              {notification.name}
            </span>{' '}
            de {notification.city}
          </p>
          <p className="text-xs text-text-muted" data-id="element-238">
            acaba de comprar Noches de Paz
          </p>
        </div>
      </div>
    </div>;
}